export const FLOATING_VIDEO_Z_INDEX = 2147483645;
export const MOBILE_SITE_NAV_BACKDROP_Z_INDEX = FLOATING_VIDEO_Z_INDEX + 1;
export const MOBILE_SITE_NAV_Z_INDEX = MOBILE_SITE_NAV_BACKDROP_Z_INDEX + 1;
